/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useContext, useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';

// service imports
import GeneralService from '../../services/GeneralService';

// local imports
import ErrorBoundary from './ErrorBoundary';
import GeneralNavbar from './GeneralNavbar';
import ServiesImg from '../../assets/services.svg';
import Footer from './Footer';


const Service = props => {

    // contexts
    const { theme, fontFamily, fontWeight, colors } = useContext(ThemeContext);

    // states
    const [service, setService] = useState({
        name: '',
        overview: '',
        image: '',
        sections: [],
        status: ''
    });
    const [isLoading, setIsLoading] = useState(false);

    //scroll to top
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // useEffects
    useEffect(() => {
        setIsLoading(true);
        let params = new URLSearchParams(props.location.search)
        let serviceId = params.get('id')
        // console.log('serviceId', serviceId)
        try {
            GeneralService.getService(serviceId).then(data => {
                // console.log('service', data.service)
                setService({ ...data.service });
                setIsLoading(false);
            })
        } catch (err) {
            console.log(err);
        }
    }, []);

    // handle functions

    //utility function
    const createMarkup = (html) => {
        return { __html: html };
    }

    return (
        <div style={{ fontFamily: fontFamily.primary }}>
            {
                !isLoading ?
                    <div>
                        <ErrorBoundary errorAt="At General Services GeneralNavbar">
                            <GeneralNavbar history={props.history} />
                        </ErrorBoundary>

                        <div className="row p-3 px-5" style={{ background: "rgba(184, 247, 255, 0.3)" }}>
                            <div className="col-md-8 col-12 mt-5">
                                <h1 id="services-heading" className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>{service.name}</h1>
                                <p id="desc-para" style={{ fontSize: "1.2rem", maxWidth: "400px" }}>
                                    {service.overview}
                                </p>
                                <Link to={{
                                    pathname: '/serviceRequest',
                                    search: `?id=${service._id}`,
                                    state: { serviceId: service._id, serviceName: service.name }
                                }}>
                                    <button className='btn px-3 my-3' style={theme.generalNavButton}>Register</button>
                                </Link>
                            </div>
                            <img className="col-md-4 col-12" src={service.image} alt="img" />
                        </div>




                        <div className='px-5'>

                            {service.sections.map((item, index) => (

                                <div className='mt-5'>
                                    <h2>{item.title}</h2>

                                    <div dangerouslySetInnerHTML={createMarkup(item.description)}></div>
                                    <br />
                                    <hr />

                                </div>



                            ))}


                        </div>

                        <Footer />

                    </div>

                    : null
            }
        </div>
    )

}

export default Service;